require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/core-js/modules/es7.symbol.observable.js
// module id = uc+e
// module chunks = a74a